import styled from '@emotion/styled';
import React from 'react';

import {
  Menu,
  MenuItem,
  MenuProps,
  Theme,
  Typography,
  alpha,
  useTheme
} from '@mui/material';
import * as ds from './dataService';


const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    {...props}
  />
))(({ theme }: { theme: Theme }) => ({

  '& .MuiPaper-root': {
    borderRadius: 6,
    // marginTop: theme.spacing(1),
    minWidth: '18rem',
    padding: '.5rem',

    boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0'
    },
    '& .MuiMenuItem-root': {
      alignItems: 'center',
      '& .MuiSvgIcon-root': {
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        )
      }
    }
  }
}));


export type UserMenuProps = {
  handleClose: () => void;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
  open: boolean;
  anchorEl: null | HTMLElement;
  personId: string;
  isActive: boolean;
};


/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: UserMenuProps) => {
  const theme = useTheme();
  const [fnUpdatePersonStatus] = ds.useEnableDisableAccount();

  return (
    <StyledMenu
      theme={theme}
      open={props.open}
      anchorEl={props.anchorEl}
      onClose={() => props.handleClose()}
    >
      <MenuItem
        key={1}
        onClick={() => {
          fnUpdatePersonStatus({
            id: props.personId
          });
          props.handleClose();
        }}

      >
        <Typography variant='dropDownMenuItem'>{props.isActive ? 'Disable' : 'Enable'} User Account</Typography>
      </MenuItem>
    </StyledMenu>
  );
};
